export default __webpack_public_path__ + "static/media/lotusMask.054ae70b.svg";